import React from 'react';
import DocumentationPages from './Documentation';
import { Route, RouteNotFound } from 'reaouter';
import { Local } from 'Source/App/Storage/Local';
import { localDefaults } from './local-config'; 
import { OverideStylesheet, DynamicStylesheet } from './Pages/Neumorphism/DynamicStylesheet';
import { LandingFacade } from './Facades';
import { LandingPage, PageNotFound } from './Pages';

export const Main = () => (
	<Local value={localDefaults}>
		<LandingFacade>
			<OverideStylesheet />
			<DynamicStylesheet /> 
			<Route path='/' render={<LandingPage />} />
			<Route path='/:any' nested exact={false} render={<DocumentationPages />} />
			<RouteNotFound render={<PageNotFound />} />
		</LandingFacade>
	</Local>
)